<ngrx-busy>
  <div class="safe-zone">
    <div class="hd">
      <img [src]="safeZone.preview"
        alt=""
        onerror="this.onerror=null;this.src='/assets/images/preview_not_available.svg';"
        class="preview"/>
    </div>

    <div class="info">
      <span class="title">{{safeZone.title}}</span>
      <span class="address">{{safeZone.address}}</span>
      <mat-divider></mat-divider>

      <div class="points">
        <mat-icon>wifi</mat-icon>
        {{safeZone.access_points.length}} Wi-Fi points
        <ul>
          @for (wifi of safeZone.access_points; track wifi) {
            <li>
              <i class="wifi-state"
              [ngClass]="{'wifi-ok': wifi.connection_status === AccessPointConnectionStatus.Successful, 'wifi-nc': wifi.connection_status === AccessPointConnectionStatus.NotConnectedYet}"></i>
              {{wifi.ssid}}
              @if (wifi.connection_status !== AccessPointConnectionStatus.Successful) {
                <span
                class="wifi-status">[{{wifi.connection_status | humanize:'wi_fi_states' | lowercase}}]</span>
              }
            </li>
          }
        </ul>
      </div>

      <mat-divider></mat-divider>

      <div class="points">
        <mat-icon>wifi_tethering</mat-icon>
        {{safeZone.ble_beacons.length}} beacons
        <ul>
          @for (beacon of safeZone.ble_beacons; track beacon) {
            <li>
              <app-charge [value]="beacon.battery_charge"></app-charge>
              {{beacon.name}}
            </li>
          }
        </ul>
      </div>
    </div>

    <div class="pets">
      @for (pet of safeZone.pets; track pet) {
        <img
          [src]="(pet.avatar || '/assets/images/pet.png') + '?size=small&scale=2'"
          [matTooltip]="pet.alias"
          onerror="this.src='/assets/images/pet.png';"
          class="pet"/>
      }
    </div>
  </div>
</ngrx-busy>
